import Vue from 'vue';
import moment from 'moment';

import store from './store';
import {xssSignRecover} from "./globalFunc";
import {getTimezone} from  "./util/time";
import {empty} from "./constant";

//时区转换
export function momentUtcOffset(value) {
  return moment(value).utcOffset(getTimezone());
  // const timezone = getTimezone();
  // if(timezone >0){
  //   return moment.utc(value).utcOffset(+ timezone.toString())
  // }else {
  //   return moment.utc(value).utcOffset(+ (-timezone).toString())
  // }
}

// 转换日期描述 比如January 19th, 2020
Vue.filter('formatDateDesc', function (value) {
  moment.locale(store.getters.language);
  return moment(value).format('ll');
});

// 转换日期描述 比如Mar 11.2020
Vue.filter('formatDateDescM', function (value) {
  moment.locale(store.getters.language);
  return moment(value).format('MMM DD.YYYY');
});
Vue.filter('formatDateDescMY', function (value) {
  moment.locale(store.getters.language);
  return moment(value).format('MMM YYYY');
});
Vue.filter('formatDateDescYear', function (value) {
  moment.locale(store.getters.language);
  return moment(value).format('YYYY');
});
Vue.filter('formatDateDescMD', function (value) {
  return moment(value).format('MMM DD,');
});
Vue.filter('formatDateDescYMDHM', function (value) {
  return moment(value).format('YYYY-MM-DD HH:MM');
});
Vue.filter('formatDateDescForum', function (value) {
  return moment(value).format('YYYY-MM-DD HH:mm');
});
Vue.filter('formatDateDescForum1', function (value) {
  return moment(value).format('MM-DD HH:mm');
});
Vue.filter('formatDailyTaskTime', function (value) {
  let localTime = moment.utc(value).toDate();
  return moment(localTime).format("YYYY-MM-DD HH:mm");
});
Vue.filter('formatLotteryActivityTime', function (value) {
  let localTime = moment.utc(value).toDate();
  return moment(localTime).format("YYYY-MM-DD");
});
Vue.filter('splitTime', function (value) {
  moment.locale(store.getters.language);
  return moment(value).format("YYYY-MM-DD");
});

//显示月份简称，如 Jan Mar
Vue.filter('formatMonth', function (value, area) {
  // value ? console.log('value exsit~~~~~~~~~~~~~~~~~') : console.log('value is null ~~~~~~~~~~~~~~~')
  const jaMonths = {'Jan': '一月', 'Feb': '二月', 'Mar': '三月', 'Apr': '四月', 'May': '五月', 'Jun': '六月', 'Jul': '七月',
    'Aug': '八月', 'Sep': '九月', 'Oct': '十月', 'Nov': '十一月', 'Dec': '十二月'};
  if(area=== 'us'){
    moment.locale('en');
    return moment(value).format('ll').split(',')[0].split(' ')[0];
  }
  else if (area === 'jp'){
    moment.locale('ja');
    return moment(value).format('MMM Do YY').split(' ')[0];
  }
  // return (area === 'us' ?  moment(value).format('ll').split(',')[0].split(' ')[0] :  jaMonths[moment(value).format('ll').split(',')[0].split(' ')[0]])
});

//显示日期中 日 的数字
Vue.filter('formatDay', function (value) {
  moment.locale('en');
  return moment(value).format('ll').split(',')[0].split(' ')[1];
});

Vue.filter('cosUrlTrans', function (url, width, height, needCompress,transparent) {

  if(empty(url)) return null;
  else{
    let explorer = window.navigator.userAgent;
    // console.log(explorer)
    // console.log(explorer.indexOf("Chrome"), 'chrome')
    if(needCompress){
      return (width && height) ? url + '?imageMogr2/crop/' + width + 'x' + height : url;
    }
    //判断是否为safari浏览器，safari不支持图片压缩
    if(explorer.indexOf("Safari") !== -1 && explorer.indexOf("Chrome") === -1){
      if(transparent){
        return (width && height) ? url + '?imageMogr2/crop/' + width + 'x' + height : url;
      }else{
        return (width && height) ?  url + '?imageMogr2/crop/'+ width + 'x' + height + '/format/jpg' : url + '?imageMogr2/format/jpg';
      }
    }
    else if(width && height){
      return url + '?imageMogr2/crop/'+ width + 'x' + height + '/format/webp';
    }
    else
      return url + '?imageMogr2/format/webp';
  }
});


Vue.filter('emptyHandler', function(value) {
  if (value === null || typeof value === 'undefined' || value.toString().length === 0) {
    return '-';
  }
  return value;
});


Vue.filter('shortName', function(value, length) {
  if (value === null || typeof value === 'undefined' || value.toString().length === 0) {
    return '';
  }
  return value.slice(0,length)+ '...';
});
Vue.filter('extractUrl', function(value) {
  if (value === null || typeof value === 'undefined' || value.toString().length === 0) {
    return '';
  }
  let matches = value.match(/\bhttps?:\/\/\S+/gi);
  return matches[0];
});

Vue.filter('numberHandler', function(value) {
    if (value === null || typeof value === 'undefined' || value.toString().length === 0) {
      return '';
    }else if(value.toString().length < 4){
      return value;
    }else if(value.toString().length >= 4){
      var sec = (value%1000).toString();
      return  parseInt(value/1000)  + '.' + sec.charAt(0) + 'k';
    }
});
Vue.filter('dateSlice', function(value) {
  if(value){
    return value.slice(0,16);
  }
});

Vue.filter('dateSliceYMD', function(value) {
  if(value){
    return value.slice(0,10);
  }
});

// xss过去后，英文特殊符号还原
Vue.filter('xssSignRecover', function(content) {
  return xssSignRecover(content);
});

// 距今多少天
Vue.filter('turnDaysAgo', function(value) {
  if(value){
    let creatTime = new Date(value.replace(/-/g, '/')).getTime();
    let currentTime = new Date().getTime();
    let distanceDay = (currentTime - creatTime)/86400000;
    return Math.floor(distanceDay);
  }


});
// 距今多少天
Vue.filter('orderFormat', function(order, lang) {
  if(order === 'recent' && lang === 'en')
    return 'Recent';
  else if(order === 'popular' && lang === 'en')
    return 'Popular';
  else if(order === 'score' && lang === 'en')
    return 'Score';
  else if(order === 'time' && lang === 'en')
	  return 'recruit time';
  else if(order === 'recent' && lang === 'ja')
    return '最近';
  else if(order === 'popular' && lang === 'ja')
    return '人気';
  else if(order === 'score' && lang === 'ja')
    return 'スコア';
  else if(order === 'time' && lang === 'ja')
    return 'recruit time';
});
// 匿名昵称
Vue.filter('anonymousNickname', function(value,lang) {
  if(value){
    if(value.indexOf("anonymous") !== -1 && lang === 'en'){
      return 'EmptyUser';
    }else if(value.indexOf('anonymous') !== -1 && lang === 'ja'){
      return '匿名アカウント';
    }else{
      return value;
    }
  }
});
// 匿名昵称
Vue.filter('scoreFixed', function(value) {
  if(value.slice(0,2) === '10'){
    return Number(value).toFixed(0);
  }else {
    return Number(value).toFixed(1);
  }
});
// 匿名昵称
Vue.filter('fixNumber', function(value) {
  return value.toLocaleString();
});
//超出十个字符省略好
Vue.filter('filterName',function(value){
  if(value.length>10){
    return value.slice(0,8) + '...';
  }else{
    return value;
  }
});
Vue.filter('filterNamePc',function(value){
  if(value.length>15){
    return value.slice(0,13) + '...';
  }else{
    return value;
  }
});
// 多久之前时间转换
Vue.filter('howLongBefore', function(value, lang) {
  if (value) {
    let creatTime = new Date(value.replace(/-/g, '/')).getTime();
    let now = new Date().getTime();
    let second = Math.floor((now - creatTime) / (1000));
    let minute = Math.floor(second / 60);
    let hour = Math.floor(minute / 60);
    let day = Math.floor(hour / 24);
    if (day > 0) {
      if (day >= 7) {
        moment.locale(store.getters.language);
        return moment(value).format('ll');
      }else {
        let dayTextEn = day === 1 ? ' day ago' : ' days ago';
        return lang === 'en' ? day + dayTextEn : day + '日前';
      }
    } else if (hour > 0) {
      let hourTextEn = hour === 1 ? ' hour ago' : ' hours ago';
      return lang === 'en' ? hour + hourTextEn : hour + '時間前';
    } else if (minute > 0) {
      let minuteTextEn = minute === 1 ? ' minute ago' : ' minutes ago';
      return lang === 'en' ? minute + minuteTextEn : minute + '分前';
    }  else {
      return lang === 'en' ? 'Just now' : 'さっき';
    }
  }
});
// alt 或 title截取
Vue.filter('cutOutImageAlt', function(value) {
  if(value){
    return value.slice(0,50);
  }else {
    return '';
  }
});

// 获取文章mark对应文案 -- 用于埋点
Vue.filter('getMarkText', function(value) {
  if(value === 1){
    return 'New';
  }else if(value === 2) {
    return 'Hot';
  }else if(value === 3) {
    return 'Top';
  }else {
    return 'None';
  }
});
